import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Menu, X, ChevronDown } from 'lucide-react';
export default function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [servicesDropdownOpen, setServicesDropdownOpen] = useState(false);
  const [policiesDropdownOpen, setPoliciesDropdownOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  // Handle scroll for sticky header with blur
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };
  return <header className={`w-full fixed top-0 z-50 transition-all duration-300 ${isScrolled ? 'header-blur shadow-lg py-2' : 'bg-white shadow-md py-4'}`} data-id="element-141">
      <div className="container mx-auto px-4 flex justify-between items-center" data-id="element-142">
        <Link to="/" className="flex items-center group" data-id="element-143">
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/hDXV1rDXM1m2ARqkQ9Hg8F/Medico_Favicon.png" alt="Medicolegal Psychiatry Expert Witness Logo" className="h-10 md:h-12 w-auto transition-transform group-hover:scale-110" data-id="element-144" />
          <div className="ml-3" data-id="element-145">
            <h1 className="text-primary font-serif text-lg md:text-xl font-bold" data-id="element-146">
              Medicolegal Psychiatry
            </h1>
            <p className="text-slate text-xs hidden sm:block" data-id="element-147">
              Clarity, Compassion, Expertise
            </p>
          </div>
        </Link>
        {/* Desktop Navigation */}
        <nav className="hidden lg:flex items-center space-x-6 xl:space-x-8" data-id="element-148">
          <Link to="/" className="text-primary hover:text-primary-light font-medium transition-all duration-200 hover:border-b-2 hover:border-primary pb-1 flex items-center h-10" data-id="element-149">
            Home
          </Link>
          <Link to="/about" className="text-primary hover:text-primary-light font-medium transition-all duration-200 hover:border-b-2 hover:border-primary pb-1 flex items-center h-10" data-id="element-150">
            About Dr. Syed
          </Link>
          {/* Services Dropdown */}
          <div className="relative group flex items-center h-10" onMouseEnter={() => setServicesDropdownOpen(true)} onMouseLeave={() => setServicesDropdownOpen(false)} data-id="element-151">
            <button className="flex items-center text-primary hover:text-primary-light font-medium transition-all duration-200 hover:border-b-2 hover:border-primary pb-1 h-full" data-id="element-152">
              Our Services{' '}
              <ChevronDown className="ml-1 h-4 w-4 transition-transform group-hover:rotate-180" data-id="element-153" />
            </button>
            <div className={`absolute left-0 top-full w-64 bg-white shadow-xl rounded-lg py-2 z-50 transition-all duration-200 ${servicesDropdownOpen ? 'opacity-100 visible translate-y-0' : 'opacity-0 invisible -translate-y-2 pointer-events-none'}`} data-id="element-154">
              <Link to="/services" className="block px-4 py-2 text-primary hover:bg-primary hover:text-white transition-all duration-200" onClick={() => setServicesDropdownOpen(false)} data-id="element-155">
                All Services
              </Link>
              <Link to="/services/mental-capacity" className="block px-4 py-2 text-primary hover:bg-primary hover:text-white transition-all duration-200" onClick={() => setServicesDropdownOpen(false)} data-id="element-156">
                Mental Capacity Assessments
              </Link>
              <Link to="/services/trauma-ptsd" className="block px-4 py-2 text-primary hover:bg-primary hover:text-white transition-all duration-200" onClick={() => setServicesDropdownOpen(false)} data-id="element-157">
                Trauma & PTSD Evaluations
              </Link>
              <Link to="/services/neurodevelopmental" className="block px-4 py-2 text-primary hover:bg-primary hover:text-white transition-all duration-200" onClick={() => setServicesDropdownOpen(false)} data-id="element-158">
                Neurodevelopmental Assessments
              </Link>
              <Link to="/services/forensic-risk" className="block px-4 py-2 text-primary hover:bg-primary hover:text-white transition-all duration-200" onClick={() => setServicesDropdownOpen(false)} data-id="element-159">
                Forensic & Risk Assessments
              </Link>
              <Link to="/services/specialist" className="block px-4 py-2 text-primary hover:bg-primary hover:text-white transition-all duration-200" onClick={() => setServicesDropdownOpen(false)} data-id="element-160">
                Specialist Psychiatric Evaluations
              </Link>
              <Link to="/services/clinical-negligence" className="block px-4 py-2 text-primary hover:bg-primary hover:text-white transition-all duration-200" onClick={() => setServicesDropdownOpen(false)} data-id="element-161">
                Clinical Negligence Cases
              </Link>
            </div>
          </div>
          <Link to="/faq" className="text-primary hover:text-primary-light font-medium transition-all duration-200 hover:border-b-2 hover:border-primary pb-1 flex items-center h-10" data-id="element-162">
            FAQs
          </Link>
          <Link to="/contact" className="text-primary hover:text-primary-light font-medium transition-all duration-200 hover:border-b-2 hover:border-primary pb-1 flex items-center h-10" data-id="element-163">
            Contact Us
          </Link>
          {/* Policies Dropdown */}
          <div className="relative group flex items-center h-10" onMouseEnter={() => setPoliciesDropdownOpen(true)} onMouseLeave={() => setPoliciesDropdownOpen(false)} data-id="element-164">
            <button className="flex items-center text-primary hover:text-primary-light font-medium transition-all duration-200 hover:border-b-2 hover:border-primary pb-1 h-full" data-id="element-165">
              Policies{' '}
              <ChevronDown className="ml-1 h-4 w-4 transition-transform group-hover:rotate-180" data-id="element-166" />
            </button>
            <div className={`absolute right-0 top-full w-64 bg-white shadow-xl rounded-lg py-2 z-50 transition-all duration-200 ${policiesDropdownOpen ? 'opacity-100 visible translate-y-0' : 'opacity-0 invisible -translate-y-2 pointer-events-none'}`} data-id="element-167">
              <Link to="/policies/cancellation" className="block px-4 py-2 text-primary hover:bg-primary hover:text-white transition-all duration-200" onClick={() => setPoliciesDropdownOpen(false)} data-id="element-168">
                Cancellation Policy
              </Link>
              <Link to="/policies/privacy" className="block px-4 py-2 text-primary hover:bg-primary hover:text-white transition-all duration-200" onClick={() => setPoliciesDropdownOpen(false)} data-id="element-169">
                Privacy & Cookie Policy
              </Link>
              <Link to="/policies/terms" className="block px-4 py-2 text-primary hover:bg-primary hover:text-white transition-all duration-200" onClick={() => setPoliciesDropdownOpen(false)} data-id="element-170">
                Terms & Conditions
              </Link>
            </div>
          </div>
        </nav>
        {/* Mobile Menu Button */}
        <button className="lg:hidden text-primary p-2 hover:bg-gray-100 rounded-lg transition-colors" onClick={toggleMenu} aria-label="Toggle menu" data-id="element-171">
          {isMenuOpen ? <X className="h-6 w-6" data-id="element-172" /> : <Menu className="h-6 w-6" data-id="element-173" />}
        </button>
      </div>
      {/* Mobile Navigation */}
      {isMenuOpen && <div className="lg:hidden bg-white pb-4 px-4 shadow-lg animate-fade-in-up" data-id="element-174">
          <Link to="/" className="block py-3 text-primary font-medium hover:text-primary-light hover:bg-gray-50 px-2 rounded transition-all" onClick={toggleMenu} data-id="element-175">
            Home
          </Link>
          <Link to="/about" className="block py-3 text-primary font-medium hover:text-primary-light hover:bg-gray-50 px-2 rounded transition-all" onClick={toggleMenu} data-id="element-176">
            About Dr. Syed
          </Link>
          <div className="py-2" data-id="element-177">
            <button className="flex items-center text-primary font-medium w-full justify-between hover:text-primary-light px-2 py-2 hover:bg-gray-50 rounded transition-all" onClick={() => setServicesDropdownOpen(!servicesDropdownOpen)} data-id="element-178">
              Our Services
              <ChevronDown className={`h-4 w-4 transition-transform ${servicesDropdownOpen ? 'rotate-180' : ''}`} data-id="element-179" />
            </button>
            {servicesDropdownOpen && <div className="pl-4 mt-1 space-y-1 animate-fade-in-up" data-id="element-180">
                <Link to="/services" className="block py-2 text-primary hover:text-primary-light hover:bg-gray-50 px-2 rounded transition-all" onClick={toggleMenu} data-id="element-181">
                  All Services
                </Link>
                <Link to="/services/mental-capacity" className="block py-2 text-primary hover:text-primary-light hover:bg-gray-50 px-2 rounded transition-all" onClick={toggleMenu} data-id="element-182">
                  Mental Capacity Assessments
                </Link>
                <Link to="/services/trauma-ptsd" className="block py-2 text-primary hover:text-primary-light hover:bg-gray-50 px-2 rounded transition-all" onClick={toggleMenu} data-id="element-183">
                  Trauma & PTSD Evaluations
                </Link>
                <Link to="/services/neurodevelopmental" className="block py-2 text-primary hover:text-primary-light hover:bg-gray-50 px-2 rounded transition-all" onClick={toggleMenu} data-id="element-184">
                  Neurodevelopmental Assessments
                </Link>
                <Link to="/services/forensic-risk" className="block py-2 text-primary hover:text-primary-light hover:bg-gray-50 px-2 rounded transition-all" onClick={toggleMenu} data-id="element-185">
                  Forensic & Risk Assessments
                </Link>
                <Link to="/services/specialist" className="block py-2 text-primary hover:text-primary-light hover:bg-gray-50 px-2 rounded transition-all" onClick={toggleMenu} data-id="element-186">
                  Specialist Psychiatric Evaluations
                </Link>
                <Link to="/services/clinical-negligence" className="block py-2 text-primary hover:text-primary-light hover:bg-gray-50 px-2 rounded transition-all" onClick={toggleMenu} data-id="element-187">
                  Clinical Negligence Cases
                </Link>
              </div>}
          </div>
          <Link to="/faq" className="block py-3 text-primary font-medium hover:text-primary-light hover:bg-gray-50 px-2 rounded transition-all" onClick={toggleMenu} data-id="element-188">
            FAQs
          </Link>
          <Link to="/contact" className="block py-3 text-primary font-medium hover:text-primary-light hover:bg-gray-50 px-2 rounded transition-all" onClick={toggleMenu} data-id="element-189">
            Contact Us
          </Link>
          <div className="py-2" data-id="element-190">
            <button className="flex items-center text-primary font-medium w-full justify-between hover:text-primary-light px-2 py-2 hover:bg-gray-50 rounded transition-all" onClick={() => setPoliciesDropdownOpen(!policiesDropdownOpen)} data-id="element-191">
              Policies
              <ChevronDown className={`h-4 w-4 transition-transform ${policiesDropdownOpen ? 'rotate-180' : ''}`} data-id="element-192" />
            </button>
            {policiesDropdownOpen && <div className="pl-4 mt-1 space-y-1 animate-fade-in-up" data-id="element-193">
                <Link to="/policies/cancellation" className="block py-2 text-primary hover:text-primary-light hover:bg-gray-50 px-2 rounded transition-all" onClick={toggleMenu} data-id="element-194">
                  Cancellation Policy
                </Link>
                <Link to="/policies/privacy" className="block py-2 text-primary hover:text-primary-light hover:bg-gray-50 px-2 rounded transition-all" onClick={toggleMenu} data-id="element-195">
                  Privacy & Cookie Policy
                </Link>
                <Link to="/policies/terms" className="block py-2 text-primary hover:text-primary-light hover:bg-gray-50 px-2 rounded transition-all" onClick={toggleMenu} data-id="element-196">
                  Terms & Conditions
                </Link>
              </div>}
          </div>
        </div>}
    </header>;
}